/* ------------------------------------------- */
/*   App config: config parameters init at app creation, not 'live data' that changes
/* ------------------------------------------- */


const apiRootUrl = (process.env.NODE_ENV === 'development') ? 'https://vf-techops-dev.ocasta.co' : '';
// const apiRootUrl = (process.env.NODE_ENV === 'development') ? 'https://vf-techops-proto.ocasta.co' : '';
// const apiRootUrl = (process.env.NODE_ENV === 'development') ? 'https://vf-techops-test.ocasta.co' : '';


const AppConfig = {

  // API Base URL, used to test whether we're on dev/staging/prod
  apiBaseUrl: `${apiRootUrl}/api`,

  // API data endpoints
  endpoints: {
    auth: {
      V1Authcheck: '/v1/authcheck',
      SAMLAuthenticate: '/SAML/authenticate',
    },
    crq: {
      create: '/v1/crq/upsert',
      update: '/v1/crq/upsert',
      get: '/v1/crq/get',
      search: '/v1/crq/search',
      coordinatorDashboard: '/v1/crq/dashboard',
      notificationComms: '/v1/notification/get',
      myCrqDashboard: '/v1/crq/mycrq',
    },
    groups: {
      list: '/v1/groups',
      members: '/v1/groups/members',
    },
    workInfoItems: {
      create: '/v1/workitem/upsert',
      update: '/v1/workitem/upsert',
      attachment: '/v1/workitem/attachment',
    },
    dispayOptions: {
      get: '/v1/display',
    },
    // adding a human
    approvers: {
      add: '/v1/crq/add_approver',
    },
    // adding a group of humans
    approversGroups: {
      add: '/v1/crq/add_approver_group',
    },
    // performing actions on behalf of a user, group or both
    approvals: {
      approve: '/v1/crq/approve',
    },
    sponsor: {
      set: '/v1/crq/set_sponsor',
    },
    relationships: {
      incidents: '/v1/relationship/incidents',
      configItems: '/v1/relationship/ci',
      projects: '/v1/relationship/projects',
      create: '/v1/relationship/upsert',
      delete: '/v1/relationship/delete',
    },
  },
  timezones: {
    default: 'GMT',
    mobile: 'Europe/London',
    fixed: 'GMT',
  },
};

export { AppConfig };
